import { useQuery } from "@apollo/client";
import { useEffect } from "react";
import { GET_DESIGNER_STEP_STATUS } from "../../graphql/designer-matching-profile";

export const useGetDesignerStepStatusQuery = (designerId: string) => {
  const { data, loading, error, refetch } = useQuery(GET_DESIGNER_STEP_STATUS, {
    variables: { designerId },
    skip: !designerId || designerId.trim() === '',
    fetchPolicy: 'cache-and-network',
    errorPolicy: 'all' // Continue even if there are GraphQL errors
  });

  // Handle errors using useEffect (Apollo Client 3.14.0 doesn't support onError callback)
  useEffect(() => {
    if (error) {
      console.error('❌ GraphQL Error in getDesignerStepStatus:', error);
      console.error('Error details:', {
        message: error.message,
        graphQLErrors: error.graphQLErrors,
        networkError: error.networkError,
        variables: { designerId }
      });
    }
  }, [error, designerId]);

  return {
    stepStatus: data?.getDesignerStepStatus,
    loading,
    error,
    refetch
  };
};
